export enum STUDY_TYPE {
  CBR = 2,
  RES = 1,
}

export const STUDY_TYPES = [
  { value: STUDY_TYPE.RES, displayName: 'RES' },
  { value: STUDY_TYPE.CBR, displayName: 'CBR' },
];
